<template lang="pug">
  .help-info
    .content-box
      .active-time 活动时间：{{start_time}}-{{end_time}}
      .need-txt 还需好友助力数量：
      .need-pending
        .left
          .num {{helpItem.num}}
          .txt (位)
        .right-btn 查看奖品 >
      .get-draw {{helpItem.extend.launch_progress}}
      .send-help 发起好友助力
      .line
      .rules-box
        .rule-title 活动规则：
        .rule-content(v-for="item in content_list" v-text="item")
</template>
<script type="span/ecmascript-6">
export default {
  name: 'Help',
  props: {
    helpItem: {
      type: Object,
      default: () => { },
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
  },
  watch: {
    'helpItem.rule': function () {
      let arr = []
      if (this.helpItem.rule) {
        arr = this.helpItem.rule.split(/\n/);
      }
      this.content_list = arr
    },
    'startTime': function () {
      let value = this.startTime
      this.start_time = value.replace(/-/g, '.')
    },
    'endTime': function () {
      let value = this.endTime
      this.end_time = value.replace(/-/g, '.')
    },
  },
  data () {
    return {
      content_list: [],
      start_time: '', // 开始时间
      end_time: '', // 结束时间
    }
  },
  methods: {},
  mounted () {
    let arr = []
    if (this.helpItem.rule) {
      arr = this.helpItem.rule.split(/\n/);
    }
    if (this.startTime) {
      let value = this.startTime
      if (value.indexOf('/') !== -1) {
        this.start_time = value.replace(/\//g, '.')
      } else {
        this.start_time = value.replace(/-/g, '.')
      }
    }
    if (this.endTime) {
      let value = this.endTime
      if (value.indexOf('/') !== -1) {
        this.end_time = value.replace(/\//g, '.')
      } else {
        this.end_time = value.replace(/-/g, '.')
      }
    }
    this.content_list = arr
  },
}
</script>

<style scoped lang="stylus">
.help-info
  position: relative
  margin-bottom: 15px
  min-height: 344px
  font-size 0
  padding: 14px
  padding-bottom 30px
  word-wrap break-word
  background linear-gradient(360deg,rgba(235,135,5,1) 0%,rgba(221,29,33,1) 100%)
  .content-box
    width 317px
    min-height 320px
    background linear-gradient(180deg,rgba(255,224,187,1) 0%,rgba(255,210,144,1) 100%)
    box-shadow 0px 1px 5px 0px rgba(154,0,0,0.5)
    border-radius 2px
    border 1px solid rgba(205,0,25,1)
    .active-time
      width 223px
      height 26px
      background linear-gradient(180deg,rgba(255,224,187,1) 0%,rgba(255,210,144,1) 100%)
      box-shadow 0px 1px 5px 0px rgba(255,203,127,1)
      border-radius 13px
      border 1px solid rgba(235,135,5,0.32)
      line-height 26px
      text-align center
      margin 14px 50px 14px 45px
      color #EB8705
      font-size 11px
    .need-txt
      color #DD1D21
      font-weight 500
      font-size 13px
      line-height 18px
      margin-left 27px
    .need-pending
      display flex
      justify-content space-between
      align-items center
      padding 0 23px 0 28px
      .left
        display flex
        justify-content flex-start
        align-items baseline
        font-weight bolder
        .num
          color #DD1D21
          line-height 39px
          font-size 28px
        .txt
          color #DD1D21
          width 39px
          line-height 18px
          font-size 13px
          text-align center
      .right-btn
        width 82px
        height 25px
        line-height 25px
        text-align center
        font-size 11px
        color #743410
        background rgba(249,177,84,1)
        box-shadow 0px 1px 3px 0px rgba(255,147,87,1)
        border-radius 2px
    .get-draw
      padding-left 28px
      font-size 17px
      color rgba(221,29,33,1)
      line-height 23px
      margin 6px 0 18px
    .send-help
      color #FFDAA8
      text-align center
      margin 0 auto 
      font-size 13px
      font-weight bolder
      line-height 37px
      width 271px
      height 37px
      background linear-gradient(180deg,rgba(255,5,7,1) 0%,rgba(221,29,33,1) 100%)
      box-shadow 0px 1px 6px 0px rgba(234,0,29,0.56)
    .line
      border-bottom #FF7F82 dashed 1px
      width 286px
      margin 27px auto 18px
    .rules-box
      width 100%
      box-sizing border-box
      padding 0 14px 18px 15px
      color #DD1D21
      font-size 13px
      line-height 18px
      .rule-title
        margin-bottom 9px
</style>



// WEBPACK FOOTER //
// src/components/content/modal/HelpBoss.vue